<template>
  <div
    :key="tip"
    class="weight_700 text-center loading-tip anim-fade-in font-clash-semibolds text-normal-large text-wrap"
    style="max-width: 500px; text-shadow: var(--text-shadow_drop); letter-spacing: 0.025rem"
    v-html="tip"
  ></div>
</template>

<script>
import { nextTick } from 'vue'
import { getRandomInt } from '@/helpers/helpers'
import en from '@/locales/en'

export default {
  name: 'LoadingTip',
  props: {
    fixedTip: { type: String, required: false },
  },
  data() {
    this.interval = null
    return {
      tip: '',
      tips: 0,
    }
  },
  mounted() {
    nextTick(() => {
      if (this.fixedTip) {
        this.tip = this.fixedTip
        return
      }
      this.getLoadingTip()
      this.interval = setInterval(this.getLoadingTip, 5 * 1000)
    })
  },
  beforeUnmount() {
    clearInterval(this.interval)
  },
  methods: {
    getLoadingTip() {
      this.tips += 1

      if (this.tips > 3) {
        clearInterval(this.interval)
        this.tip = this.$t('messages.loading_taking_longer')
        return
      }

      let displayedTips = []
      try {
        displayedTips = JSON.parse(localStorage.getItem('displayed_tips')) || []
      } catch (e) {
        displayedTips = []
      }

      const items = en.loading_tips || {}
      let availableTips = []
      Object.keys(items).forEach(key => {
        if (!displayedTips.includes(key)) {
          availableTips.push(key)
        }
      })

      if (availableTips.length === 0) {
        localStorage.setItem('displayed_tips', [])
        availableTips = ['_1']
      }

      const max = availableTips.length
      const idx = getRandomInt({ max })
      const res = availableTips[idx]
      if (res) {
        displayedTips = [...displayedTips, res.key]
        localStorage.setItem('displayed_tips', JSON.stringify(displayedTips))
      }
      const key = res || availableTips[0]
      this.tip = (key && this.$t(`loading_tips.${key}`)) || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.loading-tip {
  background: linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 0.5) 50%, transparent 100%);
  // border-radius: 8px;
  padding: 1rem 4rem;
}
</style>
